import { ZoneOffset, ZonedDateTime, LocalDateTime } from "js-joda";

import { ISecurityRole } from "ui/screens/security/models";

import {
  IGrantRoleFormState,
  IGrantRoleData,
  validDateFromPickerName,
  validDateToPickerName,
  accountPickerName,
  tenantPickerName,
  enterpriseWideFieldName
} from "./GrantRole.state";

export const getGrantRoleData = (values: IGrantRoleFormState, securityRole: ISecurityRole): IGrantRoleData => {
  const validDateFrom = values[validDateFromPickerName].value;
  const validDateTo = values[validDateToPickerName].value;

  return {
    account: values[accountPickerName].value.selectedItems[0],
    tenant: values[tenantPickerName].value.selectedItems[0],
    enterpriseWide: values[enterpriseWideFieldName].value,
    securityRole: securityRole,
    validDateFrom: validDateFrom ? ZonedDateTime.ofLocal(LocalDateTime.from(validDateFrom), ZoneOffset.SYSTEM, null).toInstant() : undefined,
    validDateTo: validDateTo ? ZonedDateTime.ofLocal(LocalDateTime.from(validDateTo), ZoneOffset.SYSTEM, null).toInstant() : undefined
  };
};
